import { IUpdateTreinamentoUseCase } from "../../../presentation/useCases/update/update_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateTreinamentoUseCase
 */

export class UpdateTreinamentoUseCase implements IUpdateTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateTreinamento(
    idTreinamento: number,
    ativo: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
    conteudoProgramatico: string | null,
  ): Promise<void> {
    await this.repository.updateTreinamento(
      idTreinamento,
      ativo,
      nome,
      versao,
      cargaHoraria,
      conteudoProgramatico,
    );
  }
}
